import type { DocMode } from '@blocksuite/affine/model';

// Keep in sync with packages/backend/server/src/constants/doc.constants.ts.
export const DEFAULT_DOC_MODE = 'edgeless' satisfies DocMode;
